'use client';

import type { AnchorHTMLAttributes } from 'react';
import React from 'react';
import type { LinkProps } from 'next/link';
import type { MagnoliaNode, LinkSwitchableMixin } from '@/types/cms/magnolia';
import { useGlobalMGLProps } from '@/Util/GlobalMGLPropsContext';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { facButtonCaret } from '@/Theme/SVG/Icons';
import { getNextLinkAttrs as getLink } from '@/components/linkList/getNextLinkAttrs';
import { Link as TransitionLink } from '@/Hooks/useReactTransitionProgress';

export interface LinkTypeProps extends MagnoliaNode {
  title: string;
  openNewBrowserWindow?: boolean;
  className?: string;
  showCaret?: boolean;
}
export type SwitchableLinkProps = LinkTypeProps & LinkSwitchableMixin;
export type LinkPropsType = LinkProps & AnchorHTMLAttributes<HTMLAnchorElement>;

const Link = (props: SwitchableLinkProps) => {
  const { title, linkType, className, showCaret } = props;
  const linkAttrs = getLink(props, useGlobalMGLProps());
  return (
    <TransitionLink className={classNames(linkType, className || '')} {...linkAttrs}>
      <span className="ignore-style">{title}</span>
      {showCaret && <FontAwesomeIcon icon={facButtonCaret} />}
    </TransitionLink>
  );
};

export const getNextLinkAttrs = getLink;

export default Link;
